import api from "./api";

export const HISTORY_LABEL = { requested: "Faktura anmodet", sent: "Faktura sendt", paid: "Betalt" };

export const INVOICE_STATUS = {
  unpaid: ["pending", "Ikke betalt"],
  overdue: ["no_show", "Forfalden"],
  paid: ["picked_up", "Betalt"],
  void: ["cancelled", "Annulleret"],
};

export const kr = (n) =>
  (n ?? 0).toLocaleString("da-DK", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + " kr.";

export const krOre = (ore) => (ore / 100).toLocaleString("da-DK", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " kr.";

export const isLocked = (store) => !!(store?.access?.locked && !store.impersonated && !store.is_owner);

export async function downloadPdf(url, number) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = `Faktura-${number}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
}
